import { createReducer, on } from '@ngrx/store';
import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import { Sale } from 'src/app/models/sales/sales.model';
import { User } from '../../../models/vet-users/user.model';
import * as Actions from './recovery.action';
export interface RecoveryState {
  user: User;
  isPasswordChanged: boolean;
}

export const initialState: RecoveryState = {
  user: new User(),
  isPasswordChanged: false,
};

export const recoveryReducer = createReducer(
  initialState,
  on(Actions.GetUserByRecoveryEncryptedId, (state) => {
    return {
      ...state,
      user: new User()
    };
  }),
  on(Actions.GetUserByRecoveryEncryptedIdSuccess, (state, { user }): RecoveryState => {
    return { ...state, user };
  }),
  on(Actions.ChangePassword, (state) => {
    return {
      ...state,
      isPasswordChanged: false,
    };
  }),
  on(Actions.ChangePasswordSuccess, (state, { response }): RecoveryState => {
    return { ...state, isPasswordChanged: response };
  })
);
